// Packages
import { Component } from "react";
import * as React from "react";
import { Link, withRouter } from "react-router-dom";
import QRCode from "qrcode.react";
// Styles
import "../schoolAdminPortal/schoolAdmin.css";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Modal } from "react-bootstrap";
import { parse } from "papaparse";
import csvImg from "./images/headercsv.png";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@material-ui/icons/Add";
import {
  FaRegIdBadge,
  FaPen,
  FaKey,
  FaTrash,
  FaQrcode,
  FaLink,
  FaWpforms,
  FaAngleRight,
  FaAngleDown,
  FaTimes,
} from "react-icons/fa";
// All Urls

import linkimg from "../schoolAdminPortal/images/linkimg.svg";
// Material Ui
import MaterialTable from "material-table";
import { CircularProgress, Paper, Typography } from "@material-ui/core";
import userService from "../../services/user.service";
import SchoolAdminDashboard from "./schoolAdminDashboard";
import { getFromLocalStorage } from "../../utils/webStorage";
import { BsXLg } from "react-icons/bs";
//copy import
import { CopyToClipboard } from "react-copy-to-clipboard";
//
import successimg from "../../assets/images/successimg.png";
// Assets
import menuthree from "../../assets/images/menuthree.png";
import ErrorMessage from "../../Common/ErrorMessage";
import CSVFileValidator from "csv-file-validator";
import CsvData from "./CsvData";
import SuccessDialog from "./Popups/SuccessDialog";
import ConfirmAthlete from "./Popups/ConfirmAthlete";
import CustomPopup from "./Popups/CustomPopup";
import SchoolStatus from "./SchoolAdminPages/SchoolStatus/SchoolStatus";
import PageNotFound from "../../routes/PageNotFound";
import PatchedPagination from "../../Common/PatchedPagination";
import { DataGrid } from "@mui/x-data-grid";
import LongMenu from "../../Common/actionMenu";
import { connect } from "react-redux";
import { permissionNames, userRoles } from "../../utils/constant";
import DeleteDialog from "./Popups/DeleteDialog";
import CustomSearch from "../../Common/CustomSearch";
import { Form } from "formik";
import ButtonWithToolTip from "../../Common/ButtonWithToolTip";
import PageNotFoundPage from "../../Common/PageNotFoundPage";
const requiredError = (headerName, rowNumber, columnNumber) => {
  return `<div className="red">${headerName} is required in the <strong>${rowNumber} row</strong> / <strong>${columnNumber} column</strong></div>`;
};

const validateError = (headerName, rowNumber, columnNumber) => {
  return `<div className="red">${headerName} is not valid in the <strong>${rowNumber} row</strong> / <strong>${columnNumber} column</strong></div>`;
};

const uniqueError = (headerName, rowNumber) => {
  return `<div className="red">${headerName} is not unique at the <strong>${rowNumber} row</strong></div>`;
};
const isYearValid = function (year) {
  return year.length === 4;
};

const CSVConfig = {
  headers: [
    {
      name: "First Name",
      inputName: "firstName",
      required: true,
      requiredError,
    },
    { name: "Last Name", inputName: "lastName", required: true, requiredError },
    {
      name: "Email",
      inputName: "email",
      required: true,
      requiredError,
      unique: true,
      uniqueError,
      validateError,
    },
    { name: "Contact", inputName: "contact", required: true, requiredError },
    {
      name: "Graduation Year",
      inputName: "graduationYear",
      required: true,
      requiredError,
      isYearValid,
    },
    {
      name: "Position Played",
      inputName: "positionPlayed",
      required: true,
      requiredError,
    },
    {
      name: "Jersey Number",
      inputName: "jerseyNumber",
      required: true,
      requiredError,
    },
    {
      name: "Instagram Account",
      inputName: "instagramAccount",
      required: true,
      requiredError,
    },
    {
      name: "Twitter Account",
      inputName: "twitterAccount",
      required: true,
      requiredError,
    },
  ],
};

class Storage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allSchoolList: [],
      columns: [],
      deleteId: null,
      anchorEl: null,
      open: false,
      modalId: "",
      total: null,
      submitting: false,
      emails: [],
      schoolId: getFromLocalStorage("schoolId"),
      email: "",
      value: "",
      copied: false,
      redirect: false,
      redirectToRow: false,
      openAthletDropdown: false,
      currentRowId: "",
      disabled: false,
      csvFile: null,
      csvError: [],
      sampleOpenCSV: false,
      csvData: [],
      finalCsvData: [],
      showTable: false,
      emailStatus: "",
      successPopup: false,
      ValidEmails: [],
      athleteConfirmation: false,
      resetFlag: true,
      selected: "Select Sport",
      isActive: false,
      sampleCsvPoup: false,
      filterSports: [],
      notFound: false,
      pageState: {
        isLoading: false,
        data: [],
        total: 0,
        page: 0,
        pageSize: 10,
      },
      menuPopup: false,
      userRole: "",
      searchQuery: "",
      searchedRecord: false,
      deletePopup: false,
      currentAthleteId: "",
      msg: "",
      deleteFlag: false,
      recordNotFound: "",
      emailError: false,
      emailErrorMsg: "",
      seasonId: "",
    };
    this.changeHandlerForVideoUpload =
      this.changeHandlerForVideoUpload.bind(this);
  }

  toggleSuccessDialog = () => {
    const { successPopup } = this.state;
    this.setState({
      openCSV: false,
      successPopup: !successPopup,
      submitting: false,
      showTable: false,
      csvFile: null,
      ValidEmails: [],
      athleteConfirmation: false,
    });
  };

  //pop ups
  openDialogSuccess() {
    this.setState({ openSuccess: !this.state.openSuccess });
  }
  closeDialogSuccess() {
    this.setState({ openSuccess: !this.state.openSuccess });
  }
  openDialogWrong() {
    this.setState({ openWrong: !this.state.openWrong });
  }
  closeDialogWrong() {
    this.setState({ openWrong: !this.state.openWrong });
  }

  openDialogRemoved() {
    this.setState({ openRemove: !this.state.openRemove });
  }
  closeDialogRemoved() {
    this.getAthleteByPage(this.state.pageState.page, 10);
    this.setState({ openRemove: !this.state.openRemove });
  }
  //add athelete buton pop up
  openDialogLink() {
    this.setState({ openLink: !this.state.openLink });
  }
  closeDialogLink() {
    this.setState({ openLink: !this.state.openLink });
  }
  //QR CODE POP UP
  openDialogQR() {
    this.setState({ openQR: !this.state.openQR });
  }
  closeDialogQR() {
    this.setState({ openQR: !this.state.openQR });
  }
  //CSV POP UP
  openDialogCSV() {
    this.setState({ openCSV: !this.state.openCSV });
  }
  closeDialogCSV() {
    this.setState({ openCSV: !this.state.openCSV });
  }
  //Sample CSV POP UP
  sampleOpenDialogCSV() {
    this.setState({ sampleOpenCSV: true });
  }
  sampleCloseDialogCSV() {
    this.setState({ sampleOpenCSV: false });
  }
  //end pop up

  changeHandlerForVideoUpload(event, fromBroswe) {
    let file = event.target.files[0];
    CSVFileValidator(file, CSVConfig)
      .then((csvData) => {
        if (csvData.inValidData.length > 0) {
          this.checkCsvValidation(file, csvData);
          this.setState({ csvError: csvData.inValidData });
        } else {
          this.checkCsvValidation(file, csvData);
          this.setState({ csvError: [] });
        }
      })
      .catch((err) => {});
  }

  checkCsvValidation = async (file, csvData) => {
    await this.getSeasonId();
    this.setState({ submitting: true });
    const { seasonId } = this.state;
    const text = await file.text();
    let result = parse(text, { header: true, skipEmptyLines: true });
    let fileData = result.data;
    let errorIndexes = [];
    let emails = [];
    csvData.inValidData.map((item) => {
      errorIndexes.push(item.rowIndex - 2);
    });
    if (fileData.length < 2) {
      this.state.csvError.push({ message: "Please insert at least 2 records" });
      this.setState({ resetFlag: true });
    }
    for (let i = 0; i < fileData.length; i++) {
      const checkContact = this.formatPhoneNumber(fileData[i].Contact);
      const checkEmail = this.isValidEmail(fileData[i].Email);
      const graduationYear = fileData[i]["Graduation Year"];
      if (graduationYear < seasonId) {
        this.state.csvError.push({
          message: `Graduation year must be greater than current season year <strong>${
            i + 2
          } row / 6 Column<strong>`,
        });
        this.setState({ resetFlag: true });
      }
      emails.push(fileData[i].Email);
      if (
        checkContact === false ||
        errorIndexes.includes(i) ||
        checkEmail === false
      ) {
        if (checkContact === false) {
          this.state.csvError.push({
            message: `Contact number is invalid in the <strong>${
              i + 2
            } row / 4 Column<strong>`,
          });
          this.setState({ resetFlag: true });
        }
        if (checkEmail === false) {
          this.state.csvError.push({
            message: `Email is invalid in the <strong>${
              i + 2
            } row / 3 Column<strong>`,
          });
          this.setState({ resetFlag: true });
        }
        fileData[i].status = false;
        continue;
      }

      fileData[i].status = true;
      fileData[i].Contact = checkContact;
    }

    this.setState({ csvData: fileData, submitting: false, showTable: true });
  };

  isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  checkEmail = (email) => {
    let status = "";
    userService.checkEmailInUser(email).then((response) => {
      if (response.data.data === "true") {
        status = false;
      } else {
        status = true;
      }
    });
    return status;
  };

  uploadCsv = () => {
    const emails = [];
    const { csvData } = this.state;
    for (var i = 0; i < csvData.length; i++) {
      emails.push(csvData[i].Email);
    }
    const obj = {
      emails: emails,
    };
    userService.checkEmailsInUser(obj).then((res) => {
      for (var i = 0; i < res.data.data.length; i++) {
        if (res.data.data[i].exists === true) {
          csvData[i].status = false;
          this.state.csvError.push({
            message: `Email already exists in the <strong>${
              i + 2
            } row / 3 Column<strong>`,
          });
          continue;
        }
        csvData[i].status = true;
      }
      const found = csvData.some((el) => el.status === false);
      this.setState({ csvData });

      if (!found) {
        const arrayObj = csvData.map((item) => {
          return {
            firstName: item["First Name"],
            lastName: item["Last Name"],
            email: item["Email"],
            phoneNumber: item["Contact"],
            jerseyNumber: item["Jersey Number"],
            positionPlayed: item["Position Played"],
            graduationYear: item["Graduation Year"],
            group: "",
            teamIds: [],
            schoolId: this.state.schoolId,
          };
        });

        this.setState({ finalCsvData: arrayObj, athleteConfirmation: true });
      }
    });
  };

  registerAthletes = () => {
    const { finalCsvData } = this.state;
    userService
      .addAthleteCsv(finalCsvData)
      .then((res) => {
        if (res.status === 200) {
          this.getAthleteByPage(
            this.state.pageState.page,
            this.state.pageState.pageSize
          );
          this.toggleSuccessDialog();
          this.setState({ msg: "Athlete added successfully!" });
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ athleteConfirmation: false });
      });
  };

  closeAthleteConfirmation = () => {
    this.setState({ athleteConfirmation: false });
  };

  getSeasonId = async () => {
    const res = await userService.getCurrentSeason(this.state.schoolId);
    const allSeasonList = res.data.data;
    const seasonId = allSeasonList.filter((item) => {
      return item.currentSession === true;
    });
    this.setState({ seasonId: seasonId[0].years.split(" - ")[0] });
  };

  componentDidMount() {
    const athleteone = document.getElementById("Athlete");
    const { schoolId } = this.state;
    if (athleteone) {
      athleteone.classList.add("btnActive");
    }
    const userRole = this.props.userRole;
    const assignedRights = this.props.permissionRights;
    const assignedRightsIds = assignedRights.map((item) => item.displayName);
    this.setState({
      userRole,
      assignedRights: assignedRightsIds,
      submitting: true,
    });
    this.apiForLinkGeneration(schoolId);
    this.getFilterSports(schoolId);
    this.getAthleteByPage(
      this.state.pageState.page,
      this.state.pageState.pageSize
    );
  }

  getAthleteByPage = (page, size) => {
    const { schoolId, recordNotFound } = this.state;
    this.setState({ pageState: { ...this.state.pageState, isLoading: true } });
    userService
      .getAllAthleteByPage(schoolId, page, size)
      .then((res) => {
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: res.data.data.athletes,
            isLoading: false,
            total: res.data.data.total,
            page: page,
          },
          submitting: false,
        });
        if (recordNotFound) {
          this.setRecordNotFound();
        }
      })
      .catch((err) => {
        this.setState({ submitting: false });
      });
  };

  handleClose = () => {
    this.setState({
      allSchoolList: [],
      columns: [],
      deleteId: null,
      anchorEl: null,
      open: false,
      modalId: "",
    });
  };

  toggleSampleCsvDialog = () => {
    this.setState({ sampleCsvPoup: false, openCSV: true });
  };

  openDialog = (id) => {
    this.setState({
      open: !this.state.open,
      modalId: id,
    });
  };

  deleteAthelete() {
    this.setState({
      submitting: true,
    });
    const ids = this.state.modalId;
    const id = {
      ids: [ids],
    };
    userService
      .deleteAtheleteById(id)
      .then((response) => {
        if (response.status === 200) {
          this.openDialogRemoved();
          this.getSchoolData();
        }
        this.setState({
          submitting: false,
        });
      })
      .catch((error) => {
        this.setState({
          submitting: false,
        });
        console.error("There was an error!", error);
      });
  }

  closeDialog = () => {
    this.setState({ open: !this.state.open });
  };

  closeDialogLink = () => {
    this.setState({ openLink: !this.state.openLink });
  };
  closeDialogQR = () => {
    this.setState({ openQR: !this.state.openQR });
  };
  closeDialogCSV = () => {
    this.setState({
      openCSV: !this.state.openCSV,
      csvError: [],
      showTable: false,
      csvFile: "",
    });
    document.body.style.overflow = "unset";
  };
  openDialogLink = (id) => {
    this.setState({
      openLink: !this.state.openLink,
      modalId: id,
    });
  };

  ConfirmcloseDialog = () => {
    this.setState({ open: !this.state.open });
    this.deleteAthelete();
  };

  openDialogResetPassword = (email) => {
    this.setState({ openResetPopUp: !this.state.openResetPopUp });
    var emailToReset = email;
    this.setState({ emailToReset });
  };

  closeDialogResetPassword() {
    this.setState({ openResetPopUp: !this.state.openResetPopUp });
  }

  openDialogSuccessReset() {
    this.setState({ openSuccessReset: !this.state.openSuccessReset });
  }
  closeDialogSuccessReset() {
    this.setState({ openSuccessReset: !this.state.openSuccessReset });
  }

  ConfirmResetPassword() {
    userService
      .forgotPassword(this.state.emailToReset)
      .then((response) => {
        this.openDialogSuccessReset();
        this.closeDialogResetPassword();
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  getSchoolData(option) {
    this.setState({
      submitting: true,
      notFound: false,
    });
    let schoolId = getFromLocalStorage("schoolId");
    userService
      .getAllAthleteByFilter(schoolId, option)
      .then((response) => {
        const schoolData = response.data.data;
        if (response.data.status === true) {
          if (schoolData.length !== undefined) {
            const allSchoolList = schoolData;
            const total = schoolData.total;
            this.setState({ allSchoolList, total });
          }
          this.setState({
            submitting: false,
          });
        } else {
          this.setState({ notFound: true, submitting: false });
        }
      })
      .catch((error) => {
        this.setState({
          submitting: false,
        });
        console.error("There was an error!", error);
      });
  }

  apiForLinkGeneration(schoolId) {
    const { emails } = this.state;
    userService
      .copyLinkGet(emails, schoolId)
      .then((response) => {
        var value = response.data.data.url;
        this.setState({ value });
      })
      .catch((error) => {});
  }

  downloadQRCode = () => {
    this.setState({ disabled: true });
    const canvas = document.getElementById("qrCheck");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "CZ_QR_Code.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  formatPhoneNumber(phoneNumberString) {
    let cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      let inputString = "(" + match[1] + ") " + match[2] + "-" + match[3];
      return inputString;
    } else {
      return false;
    }
  }

  filterTable = (option) => {
    this.getSchoolData(option);
    this.setState({ selected: option, isActive: false });
  };

  getFilterSports(schoolId) {
    userService
      .getSports(schoolId)
      .then((response) => {
        if (response.data.status === true) {
          const filterSports = response.data.data;
          this.setState({ filterSports });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  searchAthletes = (query, page, size) => {
    const { searchedRecord, pageState, schoolId } = this.state;
    this.setState({
      pageState: { ...pageState, isLoading: true },
      searchQuery: query,
    });
    if (!searchedRecord) {
      this.setState({ searchedRecord: true });
    }
    userService
      .searchAthletes(query, schoolId, page, size)
      .then((res) => {
        const { athletes, total } = res.data.data;
        this.setState({
          pageState: {
            ...pageState,
            data: athletes ? athletes : [],
            isLoading: false,
            total: total,
            page: page,
          },
          recordNotFound: athletes.length == 0 ? true : false,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: [],
            isLoading: false,
            total: 0,
            page: page,
          },
          recordNotFound: true,
        });
      });
  };

  deleteAthleteDialog = (id) => {
    this.setState({
      deletePopup: true,
      msg: "Are You Sure You Want to Remove this Athlete?",
      currentAthleteId: id,
    });
  };

  closeAthleteDeleteDialog = () => {
    this.setState({ deletePopup: false });
  };

  deleteCurrentAthlete = () => {
    const { searchedRecord, searchQuery, pageState } = this.state;
    this.deleteAthleteUsingId().then(() => {
      this.setState({
        deleteFlag: true,
        msg: "Athlete Removed Successfully",
        successPopup: true,
        deletePopup: false,
      });
      if (searchedRecord) {
        this.searchAthletes(searchQuery, pageState.page, 10);
      } else {
        this.getAthleteByPage(pageState.page, 10);
      }
    });
  };

  deleteAthleteUsingId = () => {
    const id = {
      ids: [this.state.currentAthleteId],
    };
    return userService.deleteAtheleteById(id);
  };

  setSearchedRecord = (value) => {
    this.setState({ searchedRecord: value });
  };

  setSearchQuery = (value) => {
    this.setState({ searchQuery: value });
  };

  setRecordNotFound = () => {
    this.setState({ recordNotFound: false });
  };

  validateMultipleEmail = (email) => {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email));
  };

  validate = (emails = "") => {
    if (emails.length === 0) {
      this.setState({
        emailErrorMsg: "Email address required",
        emailError: true,
      });
      return;
    }
    emails = emails.split(/[;,]/).map((x) => x.trim().toLocaleLowerCase());
    if (emails.length !== new Set(emails).size) {
      this.setState({ emailErrorMsg: "Email address required" });
      return false;
    } else {
      if (emails.every(this.validateMultipleEmail)) {
        this.sendInviteLink();
      } else {
        this.setState({
          emailError: true,
          emailErrorMsg: "Please Enter Valid Emails",
        });
      }
    }
  };

  sendInviteLink() {
    this.setState({ submitting: true, disabled: true, emailError: false });
    const { email, schoolId } = this.state;
    var emails = [];
    emails = email.split(",");
    this.setState({ emails });
    userService
      .sendLinkAtheletePost(emails, schoolId)
      .then((response) => {
        this.setState({
          submitting: false,
          disabled: false,
          emailError: false,
        });
        this.closeDialogLink();
        this.openDialogSuccess();
      })
      .catch((error) => {});
  }

  render() {
    const {
      submitting,
      allSchoolList,
      open,
      openLink,
      openQR,
      openCSV,
      openResetPopUp,
      openSuccessReset,
      value,
      redirect,
      redirectToRow,
      openAthletDropdown,
      currentRowId,
      disabled,
      csvError,
      sampleOpenCSV,
      csvFile,
      openRemove,
      openWrong,
      copied,
      email,
      showTable,
      csvData,
      openSuccess,
      isActive,
      selected,
      successPopup,
      athleteConfirmation,
      sampleCsvPoup,
      filterSports,
      notFound,
      userRole,
      assignedRights,
      pageState,
      searchQuery,
      searchedRecord,
      msg,
      deletePopup,
      recordNotFound,
      emailError,
      emailErrorMsg,
    } = this.state;
    const { history, currentSeason, isDrawerOpen } = this.props;

    if (redirectToRow) {
      history.push(`/athletedetails/${currentRowId}`);
    }

    if (redirect) {
      history.push("/addathlete");
    }

    const tableColumns = [
      {
        field: "jerseyNumber",
        headerName: "Jersey Number",
        flex: 1,
        minWidth: 150,
        headerClassName: "table-header bold",
        align: "center",
        renderCell: (params) => (
          <div>
            <span className="jersyNo disin blue d-flex align-items-center justify-content-center">
              {params.row.jerseyNumber}
            </span>
          </div>
        ),
      },
      {
        field: "firstName",
        headerName: "Name",
        headerAlign: "center",
        headerClassName: "table-header bold",
        flex: 1,
        minWidth: 220,
        renderCell: (params) => (
          <div className="d-flex-align-cent height-70 w-100">
            <p className="link-blue text-width-auto mg-auto">
              {params.row.firstName + " " + params.row.lastName}
            </p>
          </div>
        ),
      },
      {
        field: "email",
        headerName: "Email",
        headerClassName: "table-header bold",
        headerAlign: "center",
        align: "center",
        flex: 1,
        minWidth: 250,
      },
      {
        field: "signUpDate",
        headerName: "Signup-Date",
        flex: 1,
        minWidth: 150,
        headerClassName: "table-header bold",
        align: "center",
        headerAlign: "center",
      },
      {
        field: "positionPlayed",
        headerName: "Position",
        width: 170,
        headerClassName: "table-header bold",
        align: "center",
        headerAlign: "center",
      },
      {
        field: "phoneNumber",
        headerName: "Phone Number",
        flex: 1,
        minWidth: 180,
        headerClassName: "table-header bold",
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
          <p>{this.formatPhoneNumber(params.row.phoneNumber)}</p>
        ),
      },
      {
        field: "graduationYear",
        headerName: "Graduation Year",
        flex: 1,
        minWidth: 150,
        headerClassName: "table-header bold",
        align: "center",
        headerAlign: "center",
      },
      {
        field: "status",
        headerName: "Status",
        headerClassName: "table-header bold",
        cellClassName: "mng-z-index",
        align: "center",
        width: 150,
        headerAlign: "center",
        renderCell: (params) => (
          <SchoolStatus
            status={params.row.user.active}
            isDeleted={params.row.user.deleted}
          />
        ),
      },
      {
        headerClassName: "table-header bold",
        cellClassName: "mng-z-index2",
        headerAlign: "center",
        align: "center",
        sortable: false,
        renderCell: (params) => (
          <div>
            {userRole === userRoles.ROLE_SCHOOL_ADMIN ||
            assignedRights.includes(permissionNames.Add_Remove_Athletes) ? (
              <LongMenu
                rowData={params.row}
                openDialogResetPassword={this.openDialogResetPassword}
                openDialog={this.deleteAthleteDialog}
                navigationLink="editAthlete"
              />
            ) : null}
          </div>
        ),
      },
    ];

    return (
      <div>
        <div>
          {userRole === userRoles.ROLE_TEAM_ADMIN ||
          userRole === userRoles.ROLE_SCHOOL_ADMIN ||
          userRole === userRoles.ROLE_COACH ||
          userRole === userRoles.ROLE_ATHLETE ? (
            <div
              className={
                isDrawerOpen
                  ? "content-layout p-0"
                  : "toggle-content-layout p-0"
              }
            >
              <SchoolAdminDashboard />
              <div className="mng-header">
                <h4 className="fs-24 black bold mob-hd">
                  {selected === "Select Sport" ? "Athlete" : selected} (
                  {allSchoolList !== null && notFound === false && !submitting
                    ? pageState.total
                    : "0"}
                  )
                </h4>
                <div className="d-flex align-items-center">
                  <div className="hide-dropdn mx-3 text-right dropdown-coach d-hide">
                    <div
                      onClick={(e) => this.setState({ isActive: !isActive })}
                      className={
                        isActive ? "dropdown-btn-active cp" : "dropdown-btn cp"
                      }
                    >
                      {selected}
                      {isActive ? <FaAngleDown /> : <FaAngleRight />}
                    </div>
                    {isActive && (
                      <div name="Select Name" className="dropdownContent">
                        {filterSports.map((option, index) => (
                          <div
                            key={index}
                            onClick={() => this.filterTable(option.sportName)}
                            className="dropdownItem"
                          >
                            {option.sportName}
                          </div>
                        ))}
                        <div
                          name="all sport"
                          value="All Sport"
                          onClick={(e) => this.filterTable("Select Sport")}
                          className="dropdownItem"
                        >
                          All Sport
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="dropdown">
                    {(userRole === userRoles.ROLE_SCHOOL_ADMIN ||
                      assignedRights.includes(
                        permissionNames.Add_Remove_Athletes
                      )) &&
                    currentSeason ? (
                      <span>
                        <button
                          className={
                            openAthletDropdown
                              ? "active-addBtn"
                              : "athlete-addBtnn"
                          }
                          onClick={() =>
                            this.setState({
                              openAthletDropdown: !openAthletDropdown,
                            })
                          }
                        >
                          <p className="ml-1">
                            <AddIcon className="mr-2 addIconSc " /> Add Athlete
                          </p>
                          {openAthletDropdown ? (
                            <FaAngleDown />
                          ) : (
                            <FaAngleRight />
                          )}
                        </button>
                      </span>
                    ) : (
                      <ButtonWithToolTip
                        buttonText="Add Athelete"
                        toolTipText={`${
                          !currentSeason
                            ? "Please Create New Season Before Adding Athelete."
                            : "You Don't Have Permission To Add Athlete."
                        }`}
                      />
                    )}

                    {openAthletDropdown && (
                      <div className="dropcontent addathlete-dropdown active-athlete-dropdown">
                        <div
                          className="athlete-link-div cp border-top-white"
                          onClick={() => this.openDialogLink()}
                        >
                          <FaLink className="icn" />
                          <span>
                            <p className="lname">Generate Link</p>
                          </span>
                        </div>

                        <div
                          className="athlete-link-div cp"
                          onClick={() => this.openDialogQR()}
                        >
                          <FaQrcode className="icn" />
                          <span>
                            <p className="lname">Generate QR Code</p>
                          </span>
                        </div>

                        <div
                          className="athlete-link-div cp"
                          onClick={() => {
                            this.setState({ openCSV: true });
                            if (
                              typeof window !== "undefined" &&
                              window.document
                            ) {
                              document.body.style.overflow = "hidden";
                            }
                          }}
                        >
                          <FaWpforms className="icn" />
                          <span>
                            <p className="lname">Upload CSV</p>
                          </span>
                        </div>

                        <div
                          className="athlete-link-div l-div cp"
                          onClick={() => this.setState({ redirect: true })}
                        >
                          <FaRegIdBadge className="icn" />
                          <span>
                            <p className="lname">Add Athlete Form</p>
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="hide-dropdn-sm dropdown-coach d-hide">
                <div
                  onClick={(e) => this.setState({ isActive: !isActive })}
                  className={isActive ? "dropdown-btn-active" : "dropdown-btn"}
                >
                  {selected}
                  {isActive ? <FaAngleDown /> : <FaAngleRight />}
                </div>
                {isActive && (
                  <div name="Select Name" className=" dropdownContent">
                    {filterSports.map((option, index) => (
                      <div
                        key={index}
                        onClick={(e) => this.filterTable(option.sportName)}
                        className="dropdownItem"
                      >
                        {option.sportName}
                      </div>
                    ))}
                    <div
                      name="all sport"
                      value="All Sport"
                      onClick={(e) => this.filterTable("Select Sport")}
                      className="dropdownItem"
                    >
                      All Sport
                    </div>
                  </div>
                )}
              </div>

              {submitting && (
                <div className="content-layout-loading-animation">
                  <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
                    <CircularProgress
                      className="rounded-circle"
                      color="success"
                      sx={{ fontSize: 10, color: "#002244" }}
                      disableShrink
                    />
                  </div>
                </div>
              )}

              <div className="col-12 col-sm-12 col-md-12 col-lg-12 plr dynamic-height">
                {!submitting &&
                  (pageState.data.length > 0 || recordNotFound) && (
                    <Paper className="pd-top-20">
                      <CustomSearch
                        searchQuery={searchQuery}
                        setSearchQuery={this.setSearchQuery}
                        setSearchedRecord={this.setSearchedRecord}
                        searchedRecord={searchedRecord}
                        getDataByPage={this.getAthleteByPage}
                        pageState={pageState}
                        searchData={this.searchAthletes}
                        setRecordNotFound={this.setRecordNotFound}
                      />

                      <DataGrid
                        rows={pageState.data}
                        rowCount={pageState.total}
                        loading={pageState.isLoading}
                        pagination
                        page={pageState.page}
                        columns={tableColumns}
                        pageSize={pageState.pageSize}
                        rowsPerPageOptions={[10]}
                        paginationMode="server"
                        onPageChange={(newPage) => {
                          if (searchQuery == "") {
                            this.getAthleteByPage(newPage, 10);
                          } else {
                            this.searchAthletes(searchQuery, newPage, 10);
                          }
                          this.setState({ ...pageState, page: newPage });
                        }}
                        onPageSizeChange={(newPageSize) =>
                          this.setState({
                            ...pageState,
                            pageSize: newPageSize,
                          })
                        }
                        sx={{
                          color: "black",
                          fontFamily: "Rajdhani-SemiBold",
                          fontSize: "18px",
                          backgroundColor: "white",
                          borderBottomLeftRadius: "12px",
                          borderBottomRightRadius: "12px",
                        }}
                        onCellClick={(param) => {
                          this.setState({
                            redirectToRow: true,
                            currentRowId: param.row.id,
                          });
                        }}
                        autoHeight
                        disableColumnMenu
                        getRowHeight={() => "auto"}
                      />
                    </Paper>
                  )}
                <div className="clear20"></div>
                {submitting == false &&
                  !pageState.data.length > 0 &&
                  !recordNotFound && (
                    <div className="content-layout-loading-animation">
                      <p className="fs-20 bold">No Athlete Found</p>
                    </div>
                  )}
              </div>

              {/* SOMTHING WENT WRONG modal pop up */}
              <Dialog
                id="dialogBoxWrong"
                className="dialog-style"
                open={openWrong || false}
                onClose={this.closeDialogWrong.bind(this)}
              >
                <DialogTitle>
                  <div className="row">
                    <div className="col-1 text-right ml-auto ">
                      <BsXLg
                        onClick={this.closeDialogWrong.bind(this)}
                        className="crossview cp"
                      ></BsXLg>
                    </div>
                  </div>
                </DialogTitle>
                <DialogContent>
                  <div className="clear10"></div>
                  <div className="row">
                    <div className="col-12 text-center">
                      <p className="fs-20 semi-bold text-center">
                        Something Went Wrong..!
                      </p>
                      <div className="clear10"></div>
                    </div>
                    <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                      <button
                        type="button"
                        className="donebtn"
                        onClick={this.closeDialogWrong.bind(this)}
                      >
                        DONE
                      </button>
                    </div>
                  </div>

                  <div className="clear10"></div>

                  <div className="clear10"></div>
                </DialogContent>
              </Dialog>
              {/* modal pop up */}

              {/* ADD NEW ATHELETE DROPDOWN GENERATE LINK */}
              <Dialog
                id="dialogBoxLINK"
                open={openLink || false}
                onClose={this.closeDialogLink}
              >
                <DialogTitle className="pb-3">
                  <div className="row">
                    <div className="col-11">
                      <label className="fs-18 headingtxt1">
                        Invite People to join you
                      </label>
                    </div>
                    <div className="col-1 text-right ml-auto">
                      <BsXLg
                        onClick={this.closeDialogLink}
                        className="crossview cp"
                      ></BsXLg>
                    </div>
                  </div>
                  <hr className="mb-0 mt-1" />
                </DialogTitle>

                <DialogContent>
                  <div className="row">
                    <div className="row w-100">
                      <input
                        value={value}
                        className="linktextbox"
                        placeholder="https://dev.contendzone.com/addAtheleteWebsite"
                        onChange={({ target: { value } }) =>
                          this.setState({ value, copied: false })
                        }
                      />

                      <CopyToClipboard
                        text={value}
                        onCopy={() => this.setState({ copied: true })}
                      >
                        <span></span>
                      </CopyToClipboard>

                      <CopyToClipboard
                        text={value}
                        onCopy={() => this.setState({ copied: true })}
                      >
                        <button className="btnlinkCopy">
                          <img src={linkimg} alt="copy" className="cp"></img>
                        </button>
                      </CopyToClipboard>

                      {copied ? (
                        <span style={{ color: "red", paddingTop: "10px" }}>
                          Copied.
                        </span>
                      ) : null}
                    </div>

                    <div className="col-12 text-center">
                      <div className="clear10"></div>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control textboxlink"
                          placeholder="Add people, groups or emails"
                          value={email}
                          onChange={(e) => {
                            this.setState({ email: e.target.value });
                          }}
                        />

                        <div className="input-group-append">
                          <button
                            className="btn btn-SEND"
                            type="button"
                            onClick={() => {
                              this.validate(email);
                            }}
                          >
                            SEND
                          </button>
                        </div>
                      </div>
                      {emailError && (
                        <div className="errorMsg fs-14 medium">
                          {emailErrorMsg}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="clear10"></div>
                  <div className="clear10"></div>
                </DialogContent>
              </Dialog>
              {/* END DIALOG LINK */}

              {/* ADD NEW ATHELETE DROPDOWN GENERATE QR CODE */}
              <Dialog
                id="dialogBoxQR"
                open={openQR || false}
                onClose={this.closeDialogQR}
              >
                <DialogTitle>
                  <div className="row">
                    <div className="col-11">
                      <label className="fs-18 headingtxt1">
                        Download a QR Code
                      </label>
                    </div>
                    <div className="col-1 text-right ml-auto">
                      <BsXLg
                        onClick={this.closeDialogQR}
                        className="crossview cp"
                      ></BsXLg>
                    </div>
                  </div>
                  <hr className="mb-0 mt-1" />
                </DialogTitle>

                <DialogContent>
                  <div className="clear10"></div>
                  <div className="row">
                    <p className="fs-16 qrdwnldtxt">
                      Athletes can scan this code to fill the form.
                    </p>
                  </div>
                  <div className="clear20"></div>
                  <div className="text-center">
                    <QRCode id="qrCheck" value={value} />
                    <div className="clear20"></div>
                    <p
                      className="text-center fs-18 dwnldtxt cp"
                      onClick={() => {
                        this.downloadQRCode();
                      }}
                    >
                      Download
                    </p>
                  </div>
                  <hr></hr>
                  <div className="col-12 text-center">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control textboxlink"
                        placeholder="Add people, groups or emails"
                      />
                      <div className="input-group-append">
                        <button
                          onClick={() => {
                            this.downloadQRCode();
                          }}
                          className="btn btn-SEND"
                          disabled={disabled}
                          type="button"
                        >
                          SEND
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="clear20"></div>
                </DialogContent>
              </Dialog>
              {/* END DIALOG LINK */}

              {/* UPLOAD CSV MODAL */}
              {openCSV && (
                <div className="popup-container">
                  <div className="popup-container-innner">
                    <div className="d-flex justify-content-between w-100">
                      <h6 className="fs-20 semi-bold black">
                        {" "}
                        Upload CSV File
                      </h6>
                      <BsXLg
                        onClick={this.closeDialogCSV}
                        className="crossview cp"
                      ></BsXLg>
                    </div>

                    <div className="clear10"></div>
                    <div className="row"></div>
                    {csvFile && (
                      <b
                        className={`uploadcsvtxt bold font-20 ${
                          csvError.length === 0 ? "green" : "red"
                        }`}
                      >
                        {csvFile.name}
                      </b>
                    )}
                    <div className="clear10"></div>
                    {!showTable && !submitting && (
                      <div className="greybox">
                        <label className="uploadcsvtxt" htmlFor="file-input">
                          Click here to upload the file
                        </label>
                        <input
                          type="file"
                          name="file-input"
                          id="file-input"
                          className="file-input__input"
                          multiple
                          onChange={this.changeHandlerForVideoUpload}
                          accept=".csv"
                        />
                      </div>
                    )}
                    <div>
                      {showTable && !submitting && <CsvData data={csvData} />}
                    </div>

                    {csvError.map((el) => (
                      <p
                        className="Features red mg-top-10 font-17"
                        dangerouslySetInnerHTML={{ __html: el.message }}
                      />
                    ))}
                    <hr></hr>
                    <div className="csv-btn-container">
                      {csvError.length === 0 && showTable && (
                        <button
                          className="btn-back"
                          type="button"
                          onClick={() => this.uploadCsv()}
                        >
                          UPLOAD
                        </button>
                      )}
                      {showTable && (
                        <button
                          className="btn-back"
                          type="button"
                          onClick={() => {
                            this.setState({
                              showTable: false,
                              csvFile: null,
                              csvData: [],
                              csvError: [],
                              validEmails: [],
                              resetFlag: false,
                            });
                          }}
                        >
                          RESET
                        </button>
                      )}
                      <button
                        className="btn-back"
                        type="button"
                        onClick={() =>
                          this.setState({ sampleCsvPoup: true, openCSV: false })
                        }
                      >
                        SAMPLE CSV FILE
                      </button>
                    </div>

                    <div>
                      {submitting && (
                        <div>
                          <CircularProgress
                            className="circle-mark"
                            color="secondary"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* sample CSV */}
              <Modal
                show={sampleOpenCSV}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header className="text-left">
                  <div className="d-flex justify-content-between w-100">
                    <h6 className="fs-20 semi-bold black"> Sample CSV File</h6>
                    <BsXLg
                      onClick={() => this.sampleCloseDialogCSV()}
                      className="crossview cp"
                    ></BsXLg>
                  </div>
                </Modal.Header>
                <Modal.Body style={{ overflow: "scroll", height: "570px" }}>
                  <img alt="" src={csvImg} />
                </Modal.Body>
              </Modal>

              {/* UPLOAD CSV MODAL END */}
              {/* save modal pop up */}
              <Dialog
                id="dialogBoxCancel"
                className="dialog-style updateschool"
                open={openSuccess || false}
                onClose={this.closeDialogSuccess.bind(this)}
              >
                <DialogTitle>
                  <div className="row">
                    <div className="col-1 text-right ml-auto">
                      <BsXLg
                        onClick={this.closeDialogSuccess.bind(this)}
                        className="crossview cp"
                      ></BsXLg>
                    </div>
                  </div>
                </DialogTitle>
                <DialogContent>
                  <div className="clear10"></div>
                  <div className="row">
                    <div className="col-12 text-center">
                      <img
                        src={successimg}
                        alt="success"
                        className="successimg-new"
                      ></img>
                      <div className="clear20"></div>
                      <p className="fs-20 semi-bold text-center">
                        Invite Send successfully.
                      </p>
                      <div className="clear30"></div>
                    </div>
                    <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                      <button
                        type="button"
                        className="donebtn"
                        onClick={this.closeDialogSuccess.bind(this)}
                      >
                        Ok
                      </button>
                      {/* </Link> */}
                    </div>
                  </div>

                  <div className="clear10"></div>

                  <div className="clear10"></div>
                </DialogContent>
              </Dialog>
              {/* modal pop up */}

              <Dialog
                id="dialogBox"
                open={openResetPopUp || false}
                onClose={this.closeDialogResetPassword}
              >
                <DialogTitle>
                  <div className="row">
                    <div className="col-1 text-right ml-auto">
                      <FaTimes
                        onClick={() => {
                          this.closeDialogResetPassword();
                        }}
                        className="crossview cp"
                      />
                    </div>
                  </div>
                </DialogTitle>
                <DialogContent>
                  <div className="clear10"></div>
                  <div className="row">
                    <div className="col-12 text-center">
                      <p className="fs-20 semi-bold text-center mb-4">
                        Are you sure
                        <br />
                        you want to reset the password?
                      </p>
                    </div>
                    <div className="col-5 col-md-3 col-lg-3 ml-auto text-center">
                      <button
                        type="button"
                        className="cancelbtn canBtn nobtn"
                        onClick={() => {
                          this.closeDialogResetPassword();
                        }}
                      >
                        No
                      </button>
                    </div>
                    <div className="col-5 col-md-3 col-lg-3 mr-auto text-center ">
                      <button
                        type="button"
                        className="yes-btn delBtn"
                        onClick={() => {
                          this.ConfirmResetPassword();
                        }}
                      >
                        Yes, Reset
                      </button>
                      {/* </Link> */}
                    </div>
                  </div>
                  <div className="clear10"></div>
                  <div className="clear10"></div>
                </DialogContent>
              </Dialog>

              <Dialog
                id="dialogBoxRemove"
                open={openSuccessReset || false}
                onClose={this.closeDialogSuccessReset.bind(this)}
              >
                <DialogTitle>
                  <div className="row">
                    <div className="col-1 text-right ml-auto">
                      <FaTimes
                        onClick={this.closeDialogSuccessReset.bind(this)}
                        className="crossview cp"
                      />
                    </div>
                  </div>
                </DialogTitle>
                <DialogContent>
                  <div className="clear10"></div>
                  <div className="row">
                    <div className="col-12 text-center">
                      <img
                        src={successimg}
                        alt="success"
                        className="successimg-new"
                      ></img>
                      <p className="fs-20 semi-bold text-center">
                        Athelete Password Reset Successfully!
                      </p>
                      <div className="clear10"></div>
                    </div>
                    <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                      <Link to="/schoolathletes">
                        <button
                          type="button"
                          className="donebtn canBtn"
                          onClick={this.closeDialogSuccessReset.bind(this)}
                        >
                          DONE
                        </button>
                      </Link>
                    </div>
                  </div>

                  <div className="clear10"></div>

                  <div className="clear10"></div>
                </DialogContent>
              </Dialog>

              <SuccessDialog
                successPopUp={successPopup}
                toggleSuccessDialog={this.toggleSuccessDialog}
                msg={msg}
              />
              <ConfirmAthlete
                confirmPopUp={athleteConfirmation}
                registerAthletes={this.registerAthletes}
                closeDialog={this.closeAthleteConfirmation}
              />

              <CustomPopup
                open={sampleCsvPoup || false}
                sampleCsv={csvImg}
                closeSampleCsvDialog={this.toggleSampleCsvDialog}
              />

              <DeleteDialog
                open={deletePopup}
                closeDialog={this.closeAthleteDeleteDialog}
                deleteRecord={this.deleteCurrentAthlete}
                deleteId={null}
                msg={msg}
              />
            </div>
          ) : (
            <PageNotFoundPage />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userRole: state.loggedInUser.role,
    permissionRights: state.loggedInUser.userProfile.permissionRights,
    currentSeason: state.loggedInUser.userProfile.currentSeason,
    isDrawerOpen: state?.schoolAdminDashboardInformation.isDrawerOpen,
  };
};

export default withRouter(connect(mapStateToProps)(Storage));
